import React from 'react';
import './QuantitySelector.scss';

const QuantitySelector = (props) => {
  const {
    productName,
    quantity,
    decreaseQuantity,
    increaseQuantity,
    hasLabel,
  } = props;
  return (
    <div className="quantity-selector">
      {hasLabel && (<span className="field-label">QTY</span>)}
      <div className="controls">
        <button
          className="qty-button decrease-qty-button"
          type="button"
          disabled={quantity <= 1}
          onClick={event => decreaseQuantity(event)}
          aria-label={`Decrease the quantity of ${productName} to ${parseInt(quantity, 10) - 1}`}
        >
          <svg viewBox="0 0 8 2" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fillRule="evenodd">
              <path
                d="M6.97.452a.75.75 0 010 1.5h-6a.75.75 0 110-1.5h6z"
                fillRule="nonzero"
              />
            </g>
          </svg>
        </button>
        <input
          type="number"
          id="quantity"
          name="quantity"
          min="1"
          readOnly
          value={quantity}
        />
        <button
          className="qty-button increase-qty-button"
          type="button"
          disabled={quantity > 99}
          onClick={event => increaseQuantity(event)}
          aria-label={`Increase the quantity of ${productName} to ${parseInt(quantity, 10) + 1}`}
        >
          <svg viewBox="0 0 8 8" xmlns="http://www.w3.org/2000/svg">
            <g
              fill="none"
              fillRule="evenodd"
            >
              <path
                d="M4.182.452a.75.75 0 01.75.75v2.25h2.25a.75.75 0 010 1.5h-2.25v2.25a.75.75 0 01-1.5 0v-2.25h-2.25a.75.75 0 110-1.5h2.25v-2.25a.75.75 0 01.75-.75z"
                fillRule="nonzero"
              />
            </g>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default QuantitySelector;
